import ProductionTasks from 'layouts/production/Components/ProductionTasks';

// Libraries

// MD2 PRO
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import Card from '@mui/material/Card';

// @mui
import CircularProgress from '@mui/material/CircularProgress';

function MiddleArea({ production, relatedID, aaroQueries }) {
    // Check if production data is available
    if (!production) {
        return (
            <MDBox mt={4} display="flex" justifyContent="center" alignItems="center" height="60vh">
                <Card>
                    <MDBox p={4} textAlign="center">
                        <CircularProgress color="info" />
                        <MDTypography variant="h6" mt={2}>
                            Üretim bilgileri yükleniyor...
                        </MDTypography>
                    </MDBox>
                </Card>
            </MDBox>
        );
    }

    return (
        <MDBox>
            {/* Tasks Section */}
            <MDBox mb={2}>
                <ProductionTasks production={production} />
            </MDBox>
        </MDBox>
    );
}

export default MiddleArea;
